import type { RenderItemProps } from '@/components/StructuredVirtualList'

import { DriverItem } from './components/DriverItem'

type Props = RenderItemProps<'drivers'>

export function Item(props: Props) {
  return props.type === 'item' ? <DriverItem {...props} /> : null
}
